import { useQuery } from '@tanstack/react-query';

import ProductsService from '@/services/ProductsService';

export const RECOMMENDATION_PRODUCTS_BY_CATEGORY_QUERY_KEY = (
  categoryId: string,
) => ['recommendationProductsByCategory', categoryId];

export function useRecommendationProductsByCategory(categoryId: string) {
  const { data, isFetching } = useQuery({
    queryKey: RECOMMENDATION_PRODUCTS_BY_CATEGORY_QUERY_KEY(categoryId),
    queryFn: () => ProductsService.recommendationProductsByCategory(categoryId),
  });

  return {
    recommendation: data,
    isLoading: isFetching,
  };
}
